import { Columns, Plus } from 'lucide-react';
import { Button } from '@/ui/design-system/components/ui/button';
import { forwardRef } from 'react';

export const ColumnsButton = forwardRef(function ColumnsButton(props, ref) {
    return (
        <Button ref={ref} variant="outline" size="sm" {...props}>
            <Columns className="size-4" />
            Columns
        </Button>
    );
});

export function ShowMorePostsButton({ onClick, disabled }) {
    return (
        <Button
            variant="ghost"
            size="sm"
            onClick={onClick}
            disabled={disabled}
            className="text-primary"
        >
            <Plus className="size-4" />
            Show more posts
        </Button>
    );
}

export function HideAllPostsButton({ onClick }) {
    return (
        <Button
            variant="ghost"
            size="sm"
            onClick={onClick}
            className="text-primary"
        >
            Hide all
        </Button>
    );
}

export function PostButtonsWrapper({ children }) {
    return (
        <div className="flex justify-center gap-2 w-full mt-4">{children}</div>
    );
}
